import { To, NavigateFunction, NavigateOptions } from 'react-router-dom';

class RouterService {
  private navigator: NavigateFunction | null = null;

  public setNavigator(navigator: NavigateFunction): void {
    this.navigator = navigator;
  }

  public navigate(to: To | number, options?: NavigateOptions): any {
    if (this.navigator) {
      if (typeof to === 'number') {
        this.navigator(to);
      } else {
        this.navigator(to, options);
      }
    }
  }
}

export default new RouterService();
